import React from 'react';
import { Megaphone } from 'lucide-react';

import { useOTSTranslation } from '@/i18n/useOTSTranslation';
import { SanitizeMode, useSanitizedText } from '@/util/sanitized';

// Snow Reporter Comments are first-hand, time-sensitive notes from
// resort staff (uphill openings, mountain ops, hazards). Treat them
// as a callout — accent left border, tinted background, an icon and
// eyebrow label — so they don't get lost in the surrounding stat
// cards. Body text inherits styling from the sanitized HTML so any
// embedded "More Information »" link still picks up the global
// anchor color.

export const SnowReportComments = ({ comments }: { comments: string }) => {
  const { t } = useOTSTranslation('common');
  const cleanComments = useSanitizedText(comments, SanitizeMode.Partial);

  if (!cleanComments.trim()) return null;

  return (
    <aside className="rounded-md border border-primary/15 border-l-4 border-l-primary bg-sky-50/70 px-4 py-3 md:px-5 md:py-4">
      <div className="mb-1.5 flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wider text-primary">
        <Megaphone className="h-3.5 w-3.5 fill-none" aria-hidden />
        {t('resort.skiReport.SnowreporterComments')}
      </div>
      <div
        className="text-sm leading-relaxed text-foreground [&_a]:font-medium"
        // eslint-disable-next-line react/no-danger -- cleanComments sanitized via useSanitizedText
        dangerouslySetInnerHTML={{ __html: cleanComments }}
      />
    </aside>
  );
};
